import './styles/global.scss';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ApiError } from './api/client.js';
import { App } from './App.js';
import { AuthProvider } from './contexts/AuthContext.js';
import { supabase } from './lib/supabase.js';
import { ThemeProvider } from './contexts/ThemeContext.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // 4xx は何度投げても結果が変わらない。再試行はサーバー側の問題のときだけ。
        if (error instanceof ApiError && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

// 開発時だけ、ブラウザのコンソールから状態を覗けるようにする。
// 本番バンドルには import.meta.env.DEV の分岐ごと残らない。
if (import.meta.env.DEV) {
  (window as unknown as Record<string, unknown>)['__coderush'] = { queryClient, supabase };
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root が見つかりません');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
